/* unplugin-vue-components disabled */import { render } from "./file-item.vue?vue&type=template&id=2db6d2f3&scoped=true"
import script from "./file-item.vue?vue&type=script&lang=js"
export * from "./file-item.vue?vue&type=script&lang=js"

import "./file-item.vue?vue&type=style&index=0&id=2db6d2f3&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db6d2f3"],['__file',"src/components/uploader/file-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2db6d2f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2db6d2f3', __exports__)) {
    api.reload('2db6d2f3', __exports__)
  }
  
  module.hot.accept("./file-item.vue?vue&type=template&id=2db6d2f3&scoped=true", () => {
    api.rerender('2db6d2f3', render)
  })

}


export default __exports__